<script>
import { dateStrTodate, getLastDates } from '@/utils'
import { getRealTimeCount } from '@/api/statistics/user_remain'
import echarts from 'echarts'

export default {
  name: 'IndexRealTimeCount',
  data() {
    return {
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
        startDate: '',
        endDate: '',
        type: 2,
        yesterday: 1
      },
      loading: false
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.getTables()
    })
  },
  created() {
    this.queryParams.startDate = getLastDates(7)
    this.queryParams.endDate = getLastDates(1)
  },
  methods: {
    handleQuery() {
      this.getTables()
    },
    getTables() {
      const chart = echarts.init(this.$refs.chartContainer)
      this.loading = true
      const option = {
        title: {
          text: '下单统计'
        },
        xAxis: [{
          name: '时间',
          type: 'category',
          data: []
        }],
        legend: {
          data: ['下单数', '成功数', '下单成功率', '下单率', '人均下单次数'],
          x: 'center',
          y: 'bottom'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value}' // 使用默认的数值格式
          },
          axisLine: {
            show: false // 隐藏 y 轴的竖线
          }
        },
        toolbox: {
          show: true,
          feature: {}
        },
        tooltip: {
          trigger: 'axis'
        },
        series: [
          {
            name: '下单数',
            data: [],
            type: 'line',
            smooth: true,
            xAxisIndex: 0,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          },
          {
            name: '成功数',
            data: [],
            type: 'line',
            smooth: true,
            xAxisIndex: 0,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          },
          {
            name: '下单成功率',
            data: [],
            type: 'line',
            smooth: true,
            xAxisIndex: 0,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          },
          {
            name: '下单率',
            data: [],
            type: 'line',
            smooth: true,
            xAxisIndex: 0,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          },
          {
            name: '人均下单次数',
            data: [],
            type: 'line',
            smooth: true,
            xAxisIndex: 0,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          }
        ]
      }
      getRealTimeCount(this.queryParams).then(res => {
        this.loading = false
        const data = { orderCount: [], payCount: [], payRate: [], orderRate: [], orderCountAvg: [] }
        const date = []
        for (const i in res.data) {
          const val = res.data[i]
          date.push(dateStrTodate(val.date))
          data.orderCount.push(val.order_count)
          data.payRate.push(val.pay_rate)
          data.payCount.push(val.pay_count)
          data.orderRate.push(val.order_rate)
          data.orderCountAvg.push(val.order_count_avg)
        }
        option.xAxis[0].data = date
        option.series[0].data = data.orderCount
        option.series[1].data = data.payCount
        option.series[2].data = data.payRate
        option.series[3].data = data.orderRate
        option.series[4].data = data.orderCountAvg
        chart.setOption(option)
      })
    }
  }
}
</script>

<template>
  <el-card class="box-card">
    <el-form ref="queryForm" :model="queryParams" :inline="true">
      <el-form-item label="开始日期" prop="startDate">
        <el-date-picker
          v-model="queryParams.startDate"
          size="mini"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="结束日期" prop="startDate">
        <el-date-picker
          v-model="queryParams.endDate"
          size="mini"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item>
        <el-button :loading="loading" type="primary" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
        <!--            <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>-->
      </el-form-item>
    </el-form>
    <div ref="chartContainer" style="width: 100%; height: 400px;" />

  </el-card>
</template>

<style scoped>

</style>
